export default __webpack_public_path__ + "static/Bitrate_Test_12_h264_hp-d8a298e2be924a44b79dc1a8160bda61.avif";